import { z } from 'zod';
/**
 * Project Menu Zod schemas
 *
 * Used by both backend (serialization) and frontend (type inference from API responses).
 */
export const projectMenuItemStatusSchema = z.enum(['active', 'beta', 'hidden', 'deprecated']);
export const projectMenuItemResponseSchema = z.object({
    key: z.string(),
    label: z.string(),
    routeSegment: z.string(),
    iconKey: z.string(),
    menuGroupKey: z.string(),
    displayOrder: z.number().int(),
    status: projectMenuItemStatusSchema,
    isEnabled: z.boolean(),
    isVisible: z.boolean(),
    isConfigured: z.boolean().nullable(),
    featureKeys: z.array(z.string()),
});
export const projectMenuResponseSchema = z.object({
    items: z.array(projectMenuItemResponseSchema),
});
/**
 * Right-rail panel item Zod schemas
 */
export const projectRightRailItemResponseSchema = z.object({
    panelKey: z.string(),
    label: z.string(),
    iconKey: z.string(),
    displayOrder: z.number().int(),
    isEnabled: z.boolean(),
    applicableMenuGroups: z.array(z.string()).nullable(),
    featureKeys: z.array(z.string()),
});
export const projectRightRailResponseSchema = z.object({
    items: z.array(projectRightRailItemResponseSchema),
});
/**
 * Workspace menu item Zod schemas
 */
export const workspaceMenuItemResponseSchema = z.object({
    key: z.string(),
    label: z.string(),
    routeSegment: z.string(),
    iconKey: z.string(),
    displayOrder: z.number().int(),
    status: projectMenuItemStatusSchema,
    isEnabled: z.boolean(),
    featureKeys: z.array(z.string()),
});
export const workspaceMenuResponseSchema = z.object({
    items: z.array(workspaceMenuItemResponseSchema),
});
//# sourceMappingURL=project-menu.js.map